const getPvxDrmToken = async ({
  accessToken,
  mediaId,
  playSessionId,
}: {
  mediaId: string;
  playSessionId: string;
  accessToken: string | null;
}): Promise<string> => {
  const endpoint = `https://${window.isProduction ? 'prd' : 'acc'}.pvx.talpa.network/media/token`;

  if (!accessToken) throw new Error('Missing required data to generate DRM token');

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mediaId, playSessionId }),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate DRM token: ${String(response.status)}`);
  }

  const { token } = (await response.json()) as { token: string };
  return token;
};

export default getPvxDrmToken;
